export default "__VITE_ASSET__CEiPXIua__"